module.exports = __webpack_public_path__ + "media/src/images/page01_zu_worksheet0202-a1d2197d7ae530d5b62cb5bb084e2b9f.png";